import React from 'react';
import { AutoResizer } from 'react-base-table';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import FeatureCheck from '@components/common/FeatureCheck';
import { Retry } from '@components/common';
import { featureSelector } from '@store/common/selectors';
import { CURRENT_PRODUCT_MODE, isAppModule } from '@src/utils/constants';
import {
  getDataForColumns,
  sensitivityLogColumns,
  sensitivityAdLogColumns,
  getDataForAdColumns,
  getDataForAppColumns,
  sensitivityAppLogColumns,
} from './utils';
import { Wrapper, StyledBaseTable } from './styled';
import StyledTabs from '@components/common/Tabs';
import { useFetchSensitivityLogs } from '../../hooks/useFetchSensitivityLogs';

const { TabPane } = StyledTabs;

const getDefaultActiveKey = () => {
  if (CURRENT_PRODUCT_MODE === 'APP') return 'app-alert';
  return 'video-alert';
};

const SensitivityLogs = ({ isPopupOpen, closePopup }) => {
  const { data: sensitivityLogs = [], isFetching, isError, refetch } = useFetchSensitivityLogs();
  const dataSource = getDataForColumns(sensitivityLogs);
  const appSource = getDataForAppColumns(sensitivityLogs);
  const adDataSource = getDataForAdColumns(sensitivityLogs);
  const isAdAlertsEnabled = useSelector(featureSelector('ad_ai_alerts'));

  const defaultActiveKey = getDefaultActiveKey();

  return (
    <Modal
      width="90vw"
      title="Sensitivity Logs"
      open={isPopupOpen}
      onCancel={closePopup}
      footer={[]}
    >
      <Wrapper>
        <Retry isLoading={isFetching} showError={isError} fetchData={refetch}>
          {isAppModule ? (
            <StyledTabs defaultActiveKey={defaultActiveKey}>
              <TabPane tab="App Metric logs" key="app-alert">
                <AutoResizer>
                  {({ width, height }) => (
                    <StyledBaseTable
                      data={appSource}
                      columns={sensitivityAppLogColumns}
                      headerHeight={100}
                      estimatedRowHeight={100}
                      width={width}
                      height={height}
                    />
                  )}
                </AutoResizer>
              </TabPane>
            </StyledTabs>
          ) : (
            <StyledTabs defaultActiveKey={defaultActiveKey}>
              <TabPane tab="Video Metric logs" key="video-alert">
                <AutoResizer>
                  {({ width, height }) => (
                    <StyledBaseTable
                      data={dataSource}
                      columns={sensitivityLogColumns}
                      headerHeight={50}
                      estimatedRowHeight={100}
                      width={width}
                      height={height}
                    />
                  )}
                </AutoResizer>
              </TabPane>
              <TabPane tab="Ad Metric logs" key="ad-alert">
                {isAdAlertsEnabled ? (
                  <AutoResizer>
                    {({ width, height }) => (
                      <StyledBaseTable
                        data={adDataSource}
                        columns={sensitivityAdLogColumns}
                        headerHeight={50}
                        estimatedRowHeight={100}
                        width={width}
                        height={height}
                      />
                    )}
                  </AutoResizer>
                ) : (
                  <FeatureCheck featureName="" />
                )}
              </TabPane>
            </StyledTabs>
          )}
        </Retry>
      </Wrapper>
    </Modal>
  );
};

export default SensitivityLogs;
